import "./radioGroup.css";

const defaultOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const RadioGroup = ({
  options = defaultOptions,
  label,
  name,
  value,
  handleChange,
  disabled = false,
}) => {
  return (
    <div class="radio-group-container">
      <label>{label}</label>
      <div class="radio-container">
        {options.map((item) => {
          return (
            <label className="radio-label-container">
              <input
                type="radio"
                value={item.value}
                class="option-input radio"
                name={name}
                checked={item.value === value}
                onChange={handleChange}
                disabled={disabled}
              />
              {item.label}
            </label>
          );
        })}
      </div>
    </div>
  );
};
